// Auth0 — publishable keys (safe to store in client code)
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "dev-alrmpcah6fsf0yyl.us.auth0.com";
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "CUUIlhASVUzEMGU08B6T0NsAAhOJZVqX";
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "https://api.indiqr.com.br";
export const AUTH0_ROLES_CLAIM = "https://indiqr.com.br/roles";

export const API_BASE_URL = import.meta.env.VITE_API_URL || "https://api.indiqr.com.br/api/v1";
